export const FlightTimeRegEx = /^\d{2}:\d{2}$/;
